// extracted by mini-css-extract-plugin
export default {"bannerTextlayout":"BannerMessage_bannerTextlayout__hZJCq","heroSubtextContainer":"BannerMessage_heroSubtextContainer__BiWmk"};